exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search[data-v-42375df1] {\n  align-items: center;\n  display: flex;\n  padding: 0 16px;\n}\n.search .search__input[data-v-42375df1] {\n  flex-grow: 3;\n}\n.search .search__buttons[data-v-42375df1] {\n  display: flex;\n  flex-grow: 1;\n  justify-content: flex-end;\n}\n", ""]);

// exports
